import React from 'react';
import { Link } from 'react-router-dom';
import mangaRaiserCover from '../assets/logos/manga_raiser.jpg';

const SideProjectsPage: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-6">أعمالي الجانبية</h1>
          <p className="text-xl max-w-3xl mx-auto">
            مجموعة من الأعمال والمشاريع الجانبية التي أقوم بها بجانب مشروعي الرئيسي بركار
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Manga Raiser */}
          <div className="mb-16">
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="h-80 bg-gray-100">
                  <img src={mangaRaiserCover} alt="غلاف مانجا رايسر" className="w-full h-full object-cover" />
                </div>
                <div className="p-8">
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">مانجا رايسر</h2>
                  <p className="text-xl text-gray-600 mb-6">
                    قصة خيال وإثارة وأكشن ومغامرات ورعب من تأليفي ورسمي، تدور أحداثها في عالم تختلط فيه الاحتمالات وتتغير فيه طبيعة العالم.
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg mb-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">عن مانجا رايسر</h3>
                    <p className="text-gray-600">
                      مانجا رايسر هي قصة مصورة بأسلوب المانجا اليابانية، تجمع بين عناصر الخيال العلمي والإثارة والأكشن. تتميز بأسلوب فني فريد وقصة مشوقة تجذب القراء من مختلف الأعمار.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Media Content */}
          <div className="mb-16">
            <h2 className="text-2xl font-bold text-gray-900 mb-8 text-center">المحتوى الإعلامي</h2>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">منصة كلام</h3>
                  <p className="text-gray-600 mb-6">
                    منصة بودكاست أناقش فيها مواضيع متنوعة تتعلق بريادة الأعمال، التطوير الشخصي، والتقنية، بالإضافة إلى استضافة خبراء ورواد أعمال لمشاركة تجاربهم وخبراتهم.
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h4 className="text-lg font-bold text-gray-900 mb-3">المحتوى على وسائل التواصل الاجتماعي</h4>
                    <p className="text-gray-600">
                      أشارك محتوى متنوعاً على منصات التواصل الاجتماعي يتضمن نصائح في ريادة الأعمال، تجارب شخصية، ومعلومات قيمة في مجال التقنية وتطوير المشاريع.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="bg-gradient-to-r from-primary to-primary-dark text-white p-8 rounded-lg">
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-4">تواصل معي</h3>
              <p className="text-lg mb-6 max-w-2xl mx-auto">
                للمزيد من المعلومات حول أعمالي الجانبية أو للتعاون في مشاريع مستقبلية، لا تتردد في التواصل معي.
              </p>
              <Link to="/contact" className="inline-block bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition duration-300">
                تواصل معي
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideProjectsPage;
